
import { mapGetters, mapActions } from "vuex"
import layoutMixin from "@/mixins/layout"

export default layoutMixin.extend({
  data: () => ({
    accDeletion: false,
  }),

  computed: {
    ...mapGetters("user", ["accountDeletion"]),

    accountMerging (): boolean {
      return this.accountDeletion?.deleteReason === "OTHER_ACCOUNT"
    },
  },

  async beforeMount () {
    if (!this.$auth.loggedIn) return

    const [res, err] = await this.$api.user.findUserDeleteRequest({
      params: {
        event: this.$config.event,
      },
    })

    if (err)
      console.error(err || this.$t("unknownError"))
    else if (res?.id)
      this.setAccDeletion(res)
  },

  mounted () {
    const data = this.accountDeletion
    if (
      localStorage.getItem("removal_modal_closed") &&
      data?.deleteReason === "OTHER_ACCOUNT" &&
      data?.secondUser
    ) return
    this.accDeletion = Boolean(data)
  },

  watch: {
    accountDeletion (val) {
      if (
        localStorage.getItem("removal_modal_closed") &&
        val?.deleteReason === "OTHER_ACCOUNT" &&
        val?.secondUser
      ) return
      this.accDeletion = Boolean(val)
    },
  },

  methods: {
    ...mapActions("user", { setAccDeletion: "SET_ACCOUNT_DELETION" }),

    updateLS () {
      localStorage.setItem("removal_modal_closed", "true")
    },
  },
})
